module.exports = __webpack_public_path__ + "img/opinionSurveyReport.d23d2189.svg";